import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import useFavorites from '../../../hooks/useFavorites';
import BibleVerse from '../../../components/BibleVerse';

const PurchaseControls = ({ book }) => {
  const { toggleFavorite, isProductFavorited, loading } = useFavorites();
  const [isFavorite, setIsFavorite] = useState(false);

  useEffect(() => {
    if (book?.id) {
      setIsFavorite(isProductFavorited(book.id, 'book'));
    }
  }, [book?.id, isProductFavorited]);

  const handleFavoriteToggle = async () => {
    if (!book?.id || loading) return;
    
    const result = await toggleFavorite(book.id, 'book');
    if (result.success) {
      setIsFavorite(result.isFavorited);
    }
  };

  const availability = book?.available_product === true
    ? {
        text: 'Disponible',
        icon: 'CheckCircle',
        colorClass: 'text-success',
        bgClass: 'bg-success/10 border-success/20',
      }
    : {
        text: 'No disponible',
        icon: 'XCircle',
        colorClass: 'text-destructive',
        bgClass: 'bg-destructive/10 border-destructive/20',
      };

  const showStockWarning =
    book?.inStock && book?.stockCount > 0 && book?.stockCount <= 5;

  return (
    <>
      {/* Desktop */}
      <div className="hidden lg:block lg:col-span-4 space-y-4">
        <div className={`p-3 border rounded-lg ${availability.bgClass}`}>
          <div className="flex items-center justify-center space-x-2">
            <Icon name={availability.icon} size={18} className={availability.colorClass} />
            <span className={`font-medium text-sm ${availability.colorClass}`}>
              {availability.text}
            </span>
          </div>
        </div>

        <Button
          onClick={handleFavoriteToggle}
          className="w-full transition-colors duration-200 border"
          style={{
            backgroundColor: !isFavorite ? '#d96f00' : '',
            borderColor: !isFavorite ? 'transparent' : '',
          }}
          onMouseEnter={(e) => {
            if (!isFavorite) {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#d96f00';
              e.currentTarget.style.borderColor = '#d96f00';
              const icon = e.currentTarget.querySelector('.heart-icon');
              if (icon) icon.style.color = '#d96f00';
            }
          }}
          onMouseLeave={(e) => {
            if (!isFavorite) {
              e.currentTarget.style.backgroundColor = '#d96f00';
              e.currentTarget.style.color = '#ffffff';
              e.currentTarget.style.borderColor = 'transparent';
              const icon = e.currentTarget.querySelector('.heart-icon');
              if (icon) icon.style.color = '#ffffff';
            }
          }}
        >
          <Icon
            name="Heart"
            size={20}
            className="mr-2 heart-icon"
            style={{
              color: !isFavorite ? '#d96f00' : '#d96f00',
              transition: 'color 0.2s ease',
            }}
          />
          {isFavorite ? 'Quitar de Favoritos' : 'Agregar a Favoritos'}
        </Button>

        <BibleVerse />

        {showStockWarning && (
          <div className="p-3 bg-warning/10 border border-warning/20 rounded-lg">
            <p className="text-sm text-warning-foreground text-center">
              ⚠️ Solo quedan {book.stockCount} unidades disponibles
            </p>
          </div>
        )}
      </div>

      {/* Mobile */}
      <div className="lg:hidden sticky bottom-16 bg-background border-t border-border p-4 space-y-4">
        <div className={`p-3 border rounded-lg ${availability.bgClass}`}>
          <div className="flex items-center justify-center space-x-2">
            <Icon name={availability.icon} size={18} className={availability.colorClass} />
            <span className={`font-medium text-sm ${availability.colorClass}`}>
              {availability.text}
            </span>
          </div>
        </div>

        <Button
          onClick={handleFavoriteToggle}
          className="w-full transition-colors duration-200 border"
          style={{
            backgroundColor: !isFavorite ? '#d96f00' : '',
            borderColor: !isFavorite ? 'transparent' : '',
          }}
          onMouseEnter={(e) => {
            if (!isFavorite) {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#d96f00';
              e.currentTarget.style.borderColor = '#d96f00';
              const icon = e.currentTarget.querySelector('.heart-icon');
              if (icon) icon.style.color = '#d96f00';
            }
          }}
          onMouseLeave={(e) => {
            if (!isFavorite) {
              e.currentTarget.style.backgroundColor = '#d96f00';
              e.currentTarget.style.color = '#ffffff';
              e.currentTarget.style.borderColor = 'transparent';
              const icon = e.currentTarget.querySelector('.heart-icon');
              if (icon) icon.style.color = '#ffffff';
            }
          }}
        >
          <Icon
            name="Heart"
            size={20}
            className="mr-2 heart-icon"
            style={{
              color: !isFavorite ? '#d96f00' : '#d96f00',
              transition: 'color 0.2s ease',
            }}
          />
          {isFavorite ? 'Quitar de Favoritos' : 'Agregar a Favoritos'}
        </Button>

        <BibleVerse />

        {showStockWarning && (
          <div className="p-3 bg-warning/10 border border-warning/20 rounded-lg">
            <p className="text-sm text-warning-foreground text-center">
              ⚠️ Solo quedan {book.stockCount} unidades disponibles
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default PurchaseControls;
